const APP_FLAGS = {};
const SCHOOL_FLAGS = {
    WALLET_ENABLED: 'Wallet Beta',
    DIRECTORY: 'directory',
};
const TEAM_FLAGS = {};
const USER_FLAGS = {};
const BRAND_FLAGS = {
    AGREEMENTS_V2_UX: 'Agreements v2 UX',
    SIGNATURES: 'Signatures',
};
export { APP_FLAGS, SCHOOL_FLAGS, TEAM_FLAGS, USER_FLAGS, BRAND_FLAGS, };
